export const Footer = () => {
  return (
    <footer>
      <div className="container_12">
        <div className="grid_12 ">
          <div className="copy">
            Eden (C) <span id="copyright-year"></span> &nbsp;|&nbsp;{" "}
            <a href="/">Privacy Policy</a> | Website Template Designed by{" "}
            <a href="http://www.templatemonster.com/" rel="nofollow">
              TemplateMonster.com
            </a>
          </div>
        </div>
        <div className="clear"></div>
      </div>
    </footer>
  );
};
